import NiceModal from '@ebay/nice-modal-react';

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';

import Button from 'components/field/Button';
import DateInput from 'components/field/DateInput';
import Status from 'components/field/Status';
import StringInput from 'components/field/StringInput';
import Form from 'components/form/Form';
import FormItem from 'components/form/FormItem';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import Table from 'components/table/Table';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useModalRouter from 'hooks/useModalRouter';

import { ADVANCE_WMS_MODULE } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const WaveForm = NiceModal.create(({ modalName, id }) => {
	const [loading, setLoading] = useState(false);

	const axios = useAxiosPrivate();
	const { closeModal } = useModalRouter();

	const formMethods = useForm();
	const { reset, watch } = formMethods;

	const handleCloseModal = useCallback(() => closeModal(), [closeModal]);
	const fillForm = useCallback(async () => {
		try {
			setLoading(true);
			const response = await axios.post(ADVANCE_WMS_MODULE.GET_WAVE_BY_ID, {
				id
			});
			reset(response.data);
		} catch (error) {
			AppLogger.error(error);
		} finally {
			setLoading(false);
		}
	}, []);
	const columns = useMemo(
		() => [
			{
				id: 'sku',
				header: 'productName',
				size: 150,
				accessorKey: 'sku',
				renderCell: ({ row }) => (
					<Typography>
						{row.original.sku} - {row.original.productName}
					</Typography>
				)
			},
			{ id: 'qtyTobePicked', header: 'qtyTobePicked', size: 150, accessorKey: 'qtyTobePicked' },
			{ id: 'qtyPicked', header: 'qtyPicked', size: 150, accessorKey: 'qtyPicked' },
			{ id: 'expiryDate', header: 'expiryDate', size: 150, accessorKey: 'expiryDate' },
			{ id: 'binLocations', header: 'binLocations', size: 150, accessorKey: 'binLocations' }
		],
		[]
	);

	useEffect(() => {
		id && fillForm();
	}, [id, fillForm]);
	const colSpan = {
		md: 6,
		lg: 6
	};
	return (
		<Modal name={modalName} maxWidth="large" fullwidth>
			<ModalTitle>
				<Typography variant="p1">viewWave</Typography>
			</ModalTitle>
			<ModalContent>
				<Form formMethods={formMethods}>
					<FormItem label="waveNumber" isLoading={loading} colSpan={colSpan}>
						<StringInput name="waveNumber" disabled />
					</FormItem>
					<FormItem label="picker" isLoading={loading} colSpan={colSpan}>
						<StringInput name="fullName" disabled />
					</FormItem>
					<FormItem label="createdDate" isLoading={loading} colSpan={colSpan}>
						<DateInput name="createdDate" value={watch('createdDate')} disabled />
					</FormItem>
					<FormItem label="startDate" isLoading={loading} colSpan={colSpan}>
						<DateInput name="startDate" value={watch('startDate')} disabled />
					</FormItem>
					<FormItem label="completeDate" isLoading={loading} colSpan={colSpan}>
						<DateInput name="completionDate" value={watch('completionDate')} disabled />
					</FormItem>
					<FormItem isLoading={loading} colSpan={colSpan} label="status">
						{watch('status') && <Status value={watch('status')} />}
					</FormItem>
					<FormItem label="orderIds" isLoading={loading} colSpan={colSpan}>
						<StringInput name="orderIds" disabled />
					</FormItem>
					<FormItem isLoading={loading} colSpan={colSpan} label="binName">
						<StringInput value={watch('binName')} disabled />
					</FormItem>
					<Table data={watch('waveItems')} loading={loading} columns={columns} />
				</Form>
			</ModalContent>
			<ModalActions>
				<Button label="cancel" variant="outline" onClick={handleCloseModal} />
			</ModalActions>
		</Modal>
	);
});
export default WaveForm;
